import * as React from "react";
import {Body, Section} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    CommonHelpers,
    IFalconConvenienceApiService,
    INotification,
    INotificationService,
    SessionStorageItemEnum,
    Types
} from "@ferry/journey-services";
import {Navigate} from "react-router";
import {VersionDisplay} from "./VersionDisplay";

interface IState {
    doRedirect: boolean,
    doRedirectToEventWarningPage: boolean,
    notificationMessage: string
}

export class Layout extends React.Component<{}, IState> {
    @lazyInject(Types.NotificationService)
    private notificationService: INotificationService;

    @lazyInject(Types.FalconConvenienceApiService)
    private falconConvenienceApiService: IFalconConvenienceApiService

    constructor(props: {}) {
        super(props);
        this.state = {
            doRedirect: false,
            doRedirectToEventWarningPage: false,
            notificationMessage: "",
        };
    }

    public componentDidMount() {
        this.removeAggregatorLoadingScreen();

        this.notificationService.getFeed().subscribe((note: INotification) => {
            if (note && this.state.notificationMessage.indexOf(note.message) === -1) {
                this.setState({
                    doRedirect: true,
                    notificationMessage: `${this.state.notificationMessage}\n${note.message}`
                })
            }
        });

        if (window.location.pathname.includes("/dashboard")) {
            this.setRedirectToEventWarningPage();
        }
    }

    public render() {
        return (
            <React.Fragment>
                {(this.doRedirectToEventWarningPage()) && (<Navigate to={`/EventWarningPage`}/>)}
                <div>
                    <div>
                        <div className="container-fluid">
                            <div className="container pt-3 pb-3">
                                <Body/>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer-position">
                    <Section id="footer"/>
                </footer>
                <VersionDisplay/>
                {this.doRedirect() && (<Navigate to={`/error?e=${this.state.notificationMessage}`}/>)}
            </React.Fragment>
        );
    }

    private removeAggregatorLoadingScreen = () => {
        const loadingScreenContainer = document.getElementById("loading-screen-container");
        if (loadingScreenContainer) {
            loadingScreenContainer.classList.add("d-none");
        }
    }

    private doRedirect = (): boolean => {
        if (this.state.doRedirect) {
            this.setState({doRedirect: false});
            return true;
        }


        return false;
    }

    private doRedirectToEventWarningPage = (): boolean => {
        if (this.state.doRedirectToEventWarningPage) {
            this.setState({doRedirectToEventWarningPage: false});
            return true;
        }

        return false;
    }


    private async setRedirectToEventWarningPage() {
        const isEventWarningPageShown = CommonHelpers.getSessionStorage(SessionStorageItemEnum.SESSION_STORAGE_EVENT_WARNING_PAGE_SHOWN);
        if (isEventWarningPageShown) {
            return;
        }

        const settings: any = await this.getSettings();
        const enabledForMotor: boolean = settings?.eventWarningPage?.motor?.enabled === true;

        if (enabledForMotor) {
            this.setState({doRedirectToEventWarningPage: true});
        }

        // Remember that we will show the event warning now, so it is not shown again in the same session.
        CommonHelpers.setSessionStorage(SessionStorageItemEnum.SESSION_STORAGE_EVENT_WARNING_PAGE_SHOWN, true);
    }
    private async getSettings() {
        const observable = this.falconConvenienceApiService.getSettings();
        return await observable.toPromise();
    }
}
